"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_SIZES = void 0;
exports.FILE_SIZES = {
    MAX_AUDIO_RECORDING_MIB: 10,
    MAX_EXERCISE_IMAGE_MIB: 10,
    MAX_VIDEO_MIB: 150,
};
